module.exports = __webpack_public_path__ + "img/17.75e98029.jpg";